import type { LeaderboardPeriod, LeaderboardScope } from '@ember/shared';

export const qk = {
  me: ['me'] as const,
  myActivities: () => ['me', 'activities'] as const,
  heatmap: (activityId: string | undefined, from: string, to: string) =>
    ['me', 'heatmap', activityId ?? 'all', from, to] as const,
  stats: (activityId: string | undefined) => ['me', 'stats', activityId ?? 'all'] as const,
  statsOverview: () => ['me', 'stats', 'overview'] as const,
  sessions: (filters: Record<string, unknown>) => ['me', 'sessions', filters] as const,
  daySessions: (activityId: string | undefined, date: string) =>
    ['me', 'day-sessions', activityId ?? 'all', date] as const,
  levelInfo: () => ['me', 'level'] as const,
  achievements: (status: 'earned' | 'locked' | 'all') => ['me', 'achievements', status] as const,
  achievementsCatalog: () => ['achievements', 'catalog'] as const,
  xpHistory: () => ['me', 'xp-history'] as const,

  catalog: (filter?: { category?: string; q?: string }) =>
    ['activities', 'catalog', filter ?? {}] as const,
  catalogItem: (kind: string) => ['activities', 'catalog', kind] as const,

  publicUser: (username: string) => ['users', username] as const,
  publicHeatmap: (
    username: string,
    activityKind: string | undefined,
    from: string,
    to: string,
  ) => ['users', username, 'heatmap', activityKind ?? 'all', from, to] as const,
  publicDay: (username: string, date: string) => ['users', username, 'days', date] as const,
  publicCompletedChallenges: (username: string) =>
    ['users', username, 'challenges', 'completed'] as const,
  publicAchievements: (username: string) => ['users', username, 'achievements'] as const,
  publicActivities: (username: string) => ['users', username, 'activities'] as const,

  friends: () => ['friends'] as const,
  friendsIncoming: () => ['friends', 'requests', 'incoming'] as const,
  friendsOutgoing: () => ['friends', 'requests', 'outgoing'] as const,

  myCommunities: () => ['me', 'communities'] as const,
  communities: (q?: string) => ['communities', q ?? ''] as const,
  community: (slug: string) => ['communities', slug] as const,
  communityMembers: (slug: string) => ['communities', slug, 'members'] as const,

  leaderboard: (
    scope: LeaderboardScope,
    activityKind: string,
    period: LeaderboardPeriod,
    communityId?: string | undefined,
  ) => ['leaderboard', scope, activityKind, period, communityId ?? null] as const,

  challenges: (filter: { kind: 'active' | 'mine' | 'detail'; id?: string; status?: string }) =>
    ['challenges', filter] as const,
  adminChallenges: () => ['admin', 'challenges'] as const,

  notifications: () => ['notifications', 'list'] as const,
  notificationsUnread: () => ['notifications', 'unread'] as const,
} as const;
